(function () {

const COMMON_DOMAINS = [
"gmail.com",
"yahoo.com",
"outlook.com",
"hotmail.com",
"icloud.com",
"me.com",
"mac.com",
"live.com",
"msn.com",
"aol.com",
"proton.me",
"protonmail.com",
"att.net",
"comcast.net",
"verizon.net",
"cox.net",
"bellsouth.net",
"sbcglobal.net",
"earthlink.net",
"ymail.com",
"rocketmail.com",
"mail.com",
"gmx.com",
"zoho.com",
"fastmail.com"
];

function levenshtein(a,b){

const matrix=[];

for(let i=0;i<=b.length;i++){
matrix[i]=[i];
}

for(let j=0;j<=a.length;j++){
matrix[0][j]=j;
}

for(let i=1;i<=b.length;i++){

for(let j=1;j<=a.length;j++){

if(b.charAt(i-1)==a.charAt(j-1)){

matrix[i][j]=matrix[i-1][j-1];

}else{

matrix[i][j]=Math.min(

matrix[i-1][j-1]+1,
matrix[i][j-1]+1,
matrix[i-1][j]+1

);

}

}

}

return matrix[b.length][a.length];

}

function nearestDomain(domain){

let best=null;
let bestScore=99;

COMMON_DOMAINS.forEach(d=>{

const score=levenshtein(domain,d);

if(score<bestScore){

best=d;
bestScore=score;

}

});

if(bestScore<=2){

return best;

}

return null;

}

function validateEmail(email){

const parts=email.split("@");

if(parts.length!==2){

return null;

}

const suggested=nearestDomain(parts[1].toLowerCase());

if(suggested && suggested!==parts[1].toLowerCase()){

return parts[0]+"@"+suggested;

}

return null;

}

function attach(){

document.querySelectorAll(`
  .klaviyo-form input[type="email"],
  footer input[type="email"],
  form[action*="contact"] input[type="email"]
`).forEach(input => {

if(input.dataset.typoAttached) return;

input.dataset.typoAttached=true;

input.addEventListener("blur",function(){

const suggestion=validateEmail(this.value.trim());

const existing=this.parentNode.querySelector(".emailSuggestion");

if(existing){

existing.remove();

}

if(!suggestion){

return;

}

const div=document.createElement("div");

div.className="emailSuggestion";

div.style.marginTop="8px";
div.style.fontSize="13px";
div.style.color="#b76e79";

div.innerHTML=`Did you mean
<strong style="cursor:pointer;">${suggestion}</strong>?`;

div.querySelector("strong").onclick=()=>{

this.value=suggestion;

div.remove();

this.focus();

};

this.parentNode.appendChild(div);

});

});

}

attach();

const observer=new MutationObserver(attach);

observer.observe(document.body,{

childList:true,
subtree:true

});

})();